export type PrizmBrightness = 'onLight' | 'onDark';
